export default __webpack_public_path__ + "static/media/Smoking-Cessation.aa2ad0b2.svg";